import React from "react";
import SearchHeader from "../../Common/SearchHeader";
import CategorySearch from "../../Common/CategorySearh";
import { homecontent } from "../../../utils/Constant";

const Banner = (props) => {
  const {
    handleCategoryChange,
    selectedCategory,
    handleQueryChange,
    query,
    searchHandler,
  } = props;
  const content = homecontent?.banner;
  return (
    <div className="banner">
      <div className="banner_content">
        <SearchHeader />
        <div className="content">
          <p>{content.p}</p>
          <h2>{content.h2}</h2>
          <h1>{content.h1}</h1>
          <p className="description">{content.para}</p>
        </div>
        <CategorySearch
          handleCategoryChange={handleCategoryChange}
          handleQueryChange={handleQueryChange}
          selectedCategory={selectedCategory}
          query={query}
          searchHandler={searchHandler}
        />
      </div>
    </div>
  );
};

export default Banner;
